import React from 'react';
import classnames from 'classnames';
import stashPaddleStyles from './StashPaddles.scss';
export const StashPaddle = ({ children, className, onClick, isEnabled, dataHook })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(stashPaddleStyles['duper'], className, isEnabled && stashPaddleStyles['enabled']),
        "data-hook": dataHook
    }, isEnabled ? /*#__PURE__*/ React.createElement("a", {
        onClick: onClick
    }, children) : /*#__PURE__*/ React.createElement(React.Fragment, null, children));
};
StashPaddle.displayName = 'StashPaddle';
export default StashPaddle;
